import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { getDashboardAlphas } from '../../../actions/Dashboard/AlphasActions';
import { StateType } from '../../../reducers';
import { getUserPermissionsSelector } from '../../../reducers/AuthenticationReducer/AuthenticationSelector';
import { dashboardAlphasDataSelector, dashboardAlphasIsFetchingSelector } from '../../../reducers/DashboardReducer/Alphas/AlphasSelector';
import { DispatchConnect } from '../../../types/';
import { Welcome } from '../Welcome';

import { AlphasPropsGeneric, AlphasStateDispatchers, AlphasStateProps } from './types';
import AlphasMain from './AlphasMain';

class Alphas extends React.Component<AlphasPropsGeneric> {
  UNSAFE_componentWillMount() {
    this.props.dispatchGetAlphas();
  }

  render() {
    const isConsultant = this.props.userPermissions.includes('CONSULTANT');
    const isNoAlphas =
      this.props.data &&
      this.props.data.get('unsubmitted') === 0 &&
      this.props.data.get('active') === 0 &&
      this.props.data.get('decommissioned') === 0;
    if (isNoAlphas || (this.props.enabledIntro && !isConsultant)) {
      return <Welcome />;
    } else {
      return <AlphasMain data={this.props.data} permissions={this.props.userPermissions} isFetching={this.props.isFetching} />;
    }
  }
}

const mapStateToProps = (state: StateType): AlphasStateProps => ({
  // @ts-ignore
  data: dashboardAlphasDataSelector(state),
  // @ts-ignore
  isFetching: dashboardAlphasIsFetchingSelector(state),
  // @ts-ignore
  userPermissions: getUserPermissionsSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<any>): AlphasStateDispatchers => ({
  dispatchGetAlphas: async () => dispatch(getDashboardAlphas()),
});

export default connect<AlphasStateProps, DispatchConnect<AlphasStateDispatchers>, any, StateType>(
  mapStateToProps,
  mapDispatchToProps
)(Alphas);
